const STATUTS_VALIDES = ['cgp', 'dcr'];

export default (status) => STATUTS_VALIDES.includes(status);
